export default "__VITE_ASSET__DGlFO836__"